"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import React from "react"
import Link from "next/link"
import styles from "../TherapistsPage.module.css"

export default function ReferralsSection({
  getRouteForLeaderOnboarding,
  getMonthlyListingsClickHandler,
}) {
  return (
    <section
      style={{
        padding: "4rem 0",
        background:
          "linear-gradient(105deg, rgba(217, 217, 217, 0.30) -9.41%, rgba(37, 99, 235, 0.50) 134.98%)",
      }}
      id="referrals"
    >
      <div className={styles.container}>
        <div style={{ textAlign: "center", maxWidth: "1282px", margin: "0 auto" }}>
          <h2
            style={{
              fontSize: "2.5rem",
              color: "#092c3c",
              marginBottom: "1.5rem",
              fontWeight: "600",
            }}
          >
            Finally, a platform built specifically for group based care
          </h2>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#666",
              marginBottom: "6px",
              lineHeight: "1.6",
            }}
          >
            Without infrastructure built for the unique complexities of group work
            (of which there are many) it’s remained largely out of reach.
          </p>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#666",
              marginBottom: "3rem",
              lineHeight: "1.6",
            }}
          >
            Mental health care has always included group work, yet the average person
            doesn’t know it’s an option.
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "1.5rem",
              margin: "2rem 0",
              textAlign: "left",
            }}
          >
            <div
              style={{
                background: "white",
                padding: "42px",
                borderRadius: "15px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                borderLeft: "5px solid #00b2ff",
              }}
              className={styles.featureCard}
            >
              <h3
                style={{
                  color: "#092c3c",
                  fontSize: "1.3rem",
                  marginBottom: "0.75rem",
                  fontWeight: "600",
                }}
              >
                🔍 Search groups
              </h3>
              <p style={{ color: "#666", lineHeight: "1.5" }}>
                Finding a group should not be like finding a needle in a haystack.
              </p>
            </div>
            <div
              style={{
                background: "white",
                padding: "42px",
                borderRadius: "15px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                borderLeft: "5px solid #00b2ff",
              }}
              className={styles.featureCard}
            >
              <h3
                style={{
                  color: "#092c3c",
                  fontSize: "1.3rem",
                  marginBottom: "0.75rem",
                  fontWeight: "600",
                }}
              >
                💌 Discover groups
              </h3>
              <p style={{ color: "#666", lineHeight: "1.5" }}>
                Get a curated monthly list of upcoming groups without the listserv
                inbox overload.
              </p>
            </div>
            <div
              style={{
                background: "white",
                padding: "42px",
                borderRadius: "15px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                borderLeft: "5px solid #00b2ff",
              }}
              className={styles.featureCard}
            >
              <h3
                style={{
                  color: "#092c3c",
                  fontSize: "1.3rem",
                  marginBottom: "0.75rem",
                  fontWeight: "600",
                }}
              >
                📢 Publicize groups
              </h3>
              <p style={{ color: "#666", lineHeight: "1.5" }}>
                Dynamic groups deserve dynamic tools. Not static directories.{" "}
              </p>
            </div>
          </div>

          <div
            style={{
              background: "#D3E5B9",
              padding: "2.5rem",
              borderRadius: "20px",
              border: "1px solid rgba(0, 178, 255, 0.2)",
              marginTop: "3rem",
            }}
          >
            <h3
              style={{
                color: "#092c3c",
                fontSize: "1.8rem",
                marginBottom: "1rem",
                fontWeight: "600",
              }}
            >
              Join the ZestLife Community
            </h3>
            <p style={{ fontSize: "1.1rem", color: "#666", marginBottom: "1rem" }}>
              Connect people to the full spectrum of group-based mental health care.
            </p>

            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <a
                href={getRouteForLeaderOnboarding()}
                className={styles.btnCtaPrimary}
              >
                Join Professional Network
              </a>
              <Link href="/" className={styles.btnCtaSecondary}>
                Explore Groups
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
